const link_list = {
    routePath: 'applications',
    actionName: 'count',
    iconClass: 'fa-solid fa-calendar-check',
    title: 'My Active Application',
    search: '',
    customDashlet: false,
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }